<div class="upload-container">

  <!-- === HERO SECTION: UPLOAD STORY === -->
  <div class="story-upload-section">

    <!-- ADDED: drag events and drag-over class binding -->
    <div class="hero-card"
         [class.is-uploading]="isUploadingStory"
         [class.drag-over]="isDragOver"
         (dragenter)="onDragEnter($event)"
         (dragover)="onDragOver($event)"
         (dragleave)="onDragLeave($event)"
         (drop)="onDrop($event)">

      <!-- State: Uploading -->
      <div *ngIf="isUploadingStory" class="loading-state">
        <div class="spinner-border text-primary mb-3" role="status" style="width: 3rem; height: 3rem;">
          <span class="visually-hidden"></span>
        </div>
        <h5>Uploading Story...</h5>
        <p class="text-muted">{{ uploadProgressMessage || 'Please wait while we process your file' }}</p>
      </div>

      <!-- State: Ready / File Selected -->
      <div *ngIf="!isUploadingStory" class="ready-state">
        <div class="icon-wrapper mb-3">
          <!-- Change icon based on drag state -->
          <i class="fa fa-4x text-primary" [ngClass]="isDragOver ? 'fa-arrow-circle-down' : 'fa-file-text'"></i>
        </div>

        <!-- Change text based on drag state -->
        <h3 class="mb-2">{{ isDragOver ? 'Drop file here' : 'Upload Story' }}</h3>
        <p class="text-muted mb-4">{{ isDragOver ? 'Release to upload' : 'Drag & drop your file here or browse' }}</p>

        <!-- Hidden File Input -->
        <input type="file"
               id="coreFile"
               class="d-none"
               accept=".txt,.docx,.pdf,.md,.html"
               (change)="onStorySelected()"
               #fileInputDocx
               [disabled]="isUploadingStory">

        <!-- Buttons (Hide during drag over to clean up UI) -->
        <div class="actions" *ngIf="!fileName && !isDragOver">
          <label for="coreFile" class="btn btn-primary btn-lg px-5 shadow-sm">
            <i class="fa fa-cloud-upload me-2"></i> Choose Story File
          </label>
        </div>

        <!-- Selected File Feedback -->
        <div *ngIf="fileName && !isDragOver" class="selected-file mt-4 fade-in">
          <div class="alert alert-success d-inline-flex align-items-center mb-0 py-2 px-4 shadow-sm">
            <i class="fa fa-check-circle me-2"></i>
            <span class="fw-bold me-2">{{fileName}}</span>
            <button class="btn btn-link btn-sm text-danger ms-3 p-0" (click)="clearFile()" title="Clear file">
              <i class="fa fa-trash"></i>
            </button>
          </div>
        </div>
      </div>

    </div>
  </div>

  <!-- === SECONDARY SECTION: WORKSPACE IMPORT (De-emphasized) === -->
  <div class="workspace-import-section mt-4 text-center">
    <p class="text-muted small mb-0">
      Already have a saved session?
      <!-- This link triggers the hidden input via the method added to TS -->
      <a href="javascript:void(0)" (click)="triggerWorkspaceUpload()" class="fw-bold text-decoration-none ms-1">
        Import existing workspace
      </a>
    </p>

    <!-- Hidden Input for Workspace -->
    <input type="file"
           id="workspaceFile"
           class="d-none"
           (change)="onWorkspaceSelected($event)"
           accept=".html"
           #workspaceInput>

    <!-- Minimal feedback for workspace upload -->
    <ng-container *ngIf="fileName$ | async as workspaceFileName">
      <div class="mt-2 fade-in" *ngIf="activeUploadMethod === 'workspace'">
         <span class="badge bg-light text-dark border p-2">
           <i class="fa fa-spinner fa-spin me-1"></i> Loading: {{workspaceFileName}}
         </span>
      </div>
    </ng-container>
  </div>

  <!-- === ALERTS: TEMPLATE MISMATCH === -->
  <div *ngIf="showMismatchContent" class="alert alert-warning mt-4 mx-auto shadow-sm" style="max-width: 700px;">
    <h6><i class="fa fa-exclamation-triangle me-2"></i> Template Mismatch</h6>
    <p>The uploaded workspace file contains columns that don't match any available template. Test data associated with the previous template was not loaded:</p>
    <ul class="mb-0 small">
      <li *ngFor="let col of mismatchColumns">{{ col }}</li>
    </ul>
    <p class="mt-2 small text-muted">The rest of the workspace data (like story content) has been restored.</p>
  </div>

</div>

<!-- Placeholder for external table components controlled by this view -->
<div class="test-table-container" [class.d-none]="showMismatchContent">
</div>
